import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import React from "react";
import { MBL_SIZE, TBL_SIZE } from "@directv-digital/dds.ui.dtv-theme";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import { CarouselCardImage } from "../../package-carousel.props";

const RenderImage = (props: CarouselCardImage & { imgLoading?: "eager" | "lazy" }) => {
  const { url, alt, width, height, objectFit, imgLoading } = props;
  try {
    return (
      <DtvBox
        sx={{
          width: {
            xs: width?.xs || "100%",
            sm: width?.sm || "100%",
            md: width?.md || "100%"
          },
          height: {
            xs: height?.xs || "auto",
            sm: height?.sm || "auto",
            md: height?.md || "auto"
          },
          "& img": {
            width: "100%",
            height: "100%",
            objectFit: {
              xs: objectFit?.xs || "cover",
              sm: objectFit?.sm || "cover",
              md: objectFit?.md || "cover"
            }
          }
        }}
      >
        <picture>
          <source media={MBL_SIZE} srcSet={url?.mobile || url?.default} />
          <source media={TBL_SIZE} srcSet={url?.tablet || url?.default} />
          <img
            alt={alt}
            decoding="async"
            loading={imgLoading}
            src={url?.default || url}
            style={{
              width: "100%",
              height: "100%"
            }}
            onError={e => {
              console.error(
                "[CarouselCard][RenderImage] untracked icon error",
                e
              );
            }}
          />
        </picture>
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="RenderImage" error={error} />;
  }
};

export default React.memo(RenderImage);
